import type { Preferences } from "../types";
import type { PremiumState } from "../contexts/PremiumContext";

/**
 * Check premium status from the PremiumContext state (RevenueCat-backed).
 */
export const isPremiumUser = (state: PremiumState): boolean => {
  return state.isPremium;
};

/**
 * Fallback check using only Firebase preferences.
 * Used internally by PremiumContext when the RevenueCat Cloud Function fails.
 * Checks eternal_subscriber only — premium_expiry is deprecated in favour of RevenueCat.
 */
export const isPremiumFromPreferences = (
  preferences: Preferences | null | undefined,
): boolean => {
  if (!preferences) return false;
  return !!preferences.eternal_subscriber;
};
